<template>
  <v-container
    :style="$vuetify.theme.dark ? '' : 'background: #eeeeee'"
    style="min-height: 100vh"
  >
    <v-row class="mb-1">
      <v-col cols="12">
        <h2 class="mt-1">
          <span class="grey--text">{{ $t("drawer.trustClients") }}</span>
        </h2>
      </v-col>
    </v-row>

    <v-row class="justify-center">
      <v-col cols="12">
        <iframe
          style="height: 2000px; width: 100%"
          src="https://trust.quickdeliverysystem.com/register"
        ></iframe
      ></v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "plan-trust",
  data() {
    return {};
  },

  computed: {
    userMe() {
      return this.$store.getters["users/userMe"];
    },
  },
};
</script>
